import { render, staticRenderFns } from "./Taxreport.vue?vue&type=template&id=58433e34&scoped=true&"
import script from "./Taxreport.vue?vue&type=script&lang=js&"
export * from "./Taxreport.vue?vue&type=script&lang=js&"
import style0 from "./Taxreport.vue?vue&type=style&index=0&id=58433e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58433e34",
  null
  
)

export default component.exports